(function () {
  'use strict';

  // ── Filter panel ────────────────────────────────────────
  var filterBtn   = document.getElementById('jc-filter-btn');
  var filterLabel = document.getElementById('jc-filter-label');
  var filterPanel = document.getElementById('jc-filter');
  var closeBtn    = document.getElementById('jc-filter-close');
  var filterOpen  = false;

  function openFilter()  {
    filterOpen = true;
    filterPanel.classList.add('is-open');
    if (filterLabel) filterLabel.textContent = 'FILTER −';
  }
  function closeFilter() {
    filterOpen = false;
    filterPanel.classList.remove('is-open');
    if (filterLabel) filterLabel.textContent = 'FILTER +';
  }

  if (filterBtn) filterBtn.addEventListener('click', function () { filterOpen ? closeFilter() : openFilter(); });
  if (closeBtn)  closeBtn.addEventListener('click', closeFilter);

  // ── Sort dropdown ────────────────────────────────────────
  var sortBtn      = document.getElementById('jc-sort-btn');
  var sortDropdown = document.getElementById('jc-sort-dropdown');
  var sortArrow    = document.getElementById('jc-sort-arrow');
  var sortOpen     = false;

  if (sortBtn) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      sortOpen = !sortOpen;
      sortDropdown.classList.toggle('is-open', sortOpen);
      sortArrow.classList.toggle('is-open', sortOpen);
    });
  }

  document.addEventListener('click', function () {
    if (sortOpen) {
      sortOpen = false;
      if (sortDropdown) sortDropdown.classList.remove('is-open');
      if (sortArrow)    sortArrow.classList.remove('is-open');
    }
  });

  // ── Card interactions ────────────────────────────────────
  document.querySelectorAll('.jc-card').forEach(function (card) {
    var media    = card.querySelector('.jc-card__media');
    var slides   = card.querySelectorAll('.jc-card__slide');
    var viewAll  = card.querySelector('.jc-card__viewall');
    var imgCount = parseInt(card.dataset.imgCount, 10) || 0;
    var current  = 0;
    var total    = Math.min(slides.length, 5);

    if (!media) return;

    var indicators  = card.querySelectorAll('.jc-card__indicator');
    var viewAllTimer = null;

    function showSlide(index) {
      if (index === current) return;
      slides[current].classList.remove('is-active');
      if (indicators[current]) indicators[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (indicators[current]) indicators[current].classList.add('is-active');
    }

    function showViewAll() {
      if (!viewAll) return;
      clearTimeout(viewAllTimer);
      viewAllTimer = setTimeout(function () {
        viewAll.classList.add('is-visible');
      }, 500);
    }

    function hideViewAll() {
      if (!viewAll) return;
      clearTimeout(viewAllTimer);
      viewAll.classList.remove('is-visible');
    }

    function resetSlide() {
      hideViewAll();
      if (current !== 0) showSlide(0);
    }

    // ── PC: マウスX座標で画像切替 ──
    if (total > 1 || imgCount > 5) {
      media.addEventListener('mousemove', function (e) {
        if (e.target.closest('.jc-card__panel') ||
            e.target.closest('.jc-card__badge')) return;

        var rect   = media.getBoundingClientRect();
        var relX   = (e.clientX - rect.left) / rect.width;
        var target = Math.min(Math.floor(relX * total), total - 1);
        target = Math.max(0, target);

        showSlide(target);

        if (viewAll) {
          if (target === total - 1 && imgCount > 5) showViewAll();
          else hideViewAll();
        }
      });

      media.addEventListener('mouseleave', resetSlide);
    }

    // ── PC: 画像エリアクリック → 商品ページ ──
    media.addEventListener('click', function (e) {
      if (e.target.closest('.jc-card__panel') ||
          e.target.closest('.jc-card__badge') ||
          e.target.closest('.jc-card__viewall')) return;
      window.location.href = card.dataset.url;
    });

    // VIEW ALL クリック → 商品ページ
    if (viewAll) {
      viewAll.addEventListener('click', function (e) {
        e.stopPropagation();
        window.location.href = card.dataset.url;
      });
    }

    // ── モバイル: タップ・スワイプ ──
    var touchStartX = 0;
    var touchStartY = 0;

    media.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    media.addEventListener('touchend', function (e) {
      var dx   = e.changedTouches[0].clientX - touchStartX;
      var dy   = e.changedTouches[0].clientY - touchStartY;
      var isTap = Math.abs(dx) < 10 && Math.abs(dy) < 10;

      if (isTap) {
        if (viewAll && viewAll.classList.contains('is-visible')) {
          window.location.href = card.dataset.url;
        } else if (total > 1 && current < total - 1) {
          showSlide(current + 1);
        } else {
          window.location.href = card.dataset.url;
        }
      } else if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 30) {
        if (dx < 0 && current < total - 1) showSlide(current + 1);
        else if (dx > 0 && current > 0)    showSlide(current - 1);
      }
    }, { passive: true });
  });

  // ── サイズボタン → Cart API ──────────────────────────────
  document.querySelectorAll('.jc-size').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // 完売サイズはカート投入不可
      if (this.classList.contains('is-sold-out')) return;

      var variantId = parseInt(this.dataset.variant, 10);
      var self      = this;
      var original  = self.textContent;

      self.textContent = '...';
      self.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.id) {
          self.textContent = '✓';
          self.classList.add('is-added');
          updateCartCount(1);
          setTimeout(function () {
            self.textContent = original;
            self.classList.remove('is-added');
            self.disabled = false;
          }, 1800);
        } else {
          self.textContent = original;
          self.disabled = false;
        }
      })
      .catch(function () {
        self.textContent = original;
        self.disabled = false;
      });
    });
  });

  function updateCartCount(add) {
    var countEl = document.querySelector('.jh-header__cart-count');
    if (countEl) {
      countEl.textContent = parseInt(countEl.textContent, 10) + add;
    } else {
      var cartLink = document.querySelector('.jh-header__icon-link[href*="cart"]');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'jh-header__cart-count';
        span.textContent = '1';
        cartLink.appendChild(span);
      }
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilter();
  });

})();
